import {
  contactSearchOptions,
  searchResultColumn,
  invoiceResultColumn,
} from './search-grid.model';
import {
  Component,
  ViewChild,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../navigation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccountingService } from '../../components/accounting/accounting.service';
import { IAccountByIdResponseObject } from '../../components/accounting/models/account.model';
import {
  IInvoiceByIdResponseObject,
  IInvoiceResponseObject,
} from '../../components/accounting/models/invoice.model';
import { TransactionsService } from '../../components/accounting/stripe/transactions.service';
import {
  IStripeLogResponse,
  IStripeLogs,
} from '../../components/accounting/stripe/transaction.interface';
import { PageEvent } from '@angular/material/paginator';
import { error } from 'console';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-search-grid',
  templateUrl: './search-grid.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './search-grid.component.scss',
})
export class SearchGridComponent implements AfterViewInit, OnInit {
  // receivedData;
  currentSortColumn: string = 'TaskId';
  currentSortDirection: string = 'desc';
  resultsColumns: any[] = [];
  currentPageSubscription: Subscription | null = null;
  page: any;
  receivedData: any = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) matSort!: MatSort;
  totalResults: number = 0;
  pageSize: number = 50;
  pageOffset: number = 0; // Default page offset
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20, 50, 100]; // Options for items per page
  displayedColumns: string[] = [];
  results: any;
  // get displayedColumns(): string[] {
  //   return this.resultsColumns.map((col) => col.key);
  // }

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private _snackBar: MatSnackBar,
    private _accountService: AccountingService,
    private _transactionService: TransactionsService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.results = navigation.extras.state['data'];
      this.receivedData = this.results.searchResults;
      this.totalResults = this.results.searchCount;
      // this.dataSource = this.receivedData
    }
  }

  ngAfterViewInit() {
    if (this.receivedData && this.matSort) {
      this.receivedData.sort = this.matSort;
    }
  }

  ngOnInit(): void {
    this.currentPageSubscription =
      this.navigationService.currentPage$.subscribe((pageName) => {
        this.page = pageName;
        // Now you can use this.page in your switch case
        this.handleColumns();
      });
  }

  handleColumns() {
    switch (this.page) {
      case 'Account':
        this.resultsColumns = contactSearchOptions;
        this.displayedColumns = this.resultsColumns.map((col) => col.key);
        break;
      case 'Payments':
        this.resultsColumns = searchResultColumn;
        this.displayedColumns = this.resultsColumns.map((col) => col.key);
        break;
      case 'Invoice':
        this.resultsColumns = invoiceResultColumn;
        this.displayedColumns = this.resultsColumns.map((col) => col.key);
        break;
    }
  }

  onSort(sort: any): void {
    // If no sort column or direction, return without changes.
    if (!sort.active || sort.direction === '') {
      return;
    }

    // Create a new array and sort it.
    this.receivedData = [...this.receivedData].sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'date':
          return this.compare(a.creationDate, b.creationDate, isAsc);
        default:
          return this.compare(a.id, b.id, isAsc);
      }
    });
    this.currentSortColumn = sort.column;
    this.currentSortDirection = sort.direction;
  }

  showDetails(row: any) {
    if (this.page == 'Account') {
      this._accountService.getContactsById(row.id).subscribe({
        next: (res: IAccountByIdResponseObject) => {
          if (!res.isError) {
            const accountData = res.value;
          }
          this.router.navigate(
            ['/klusup/accounting/account/account-details/', res.value.id],
            { state: { data: res.value } },
          );
        },
      });
    } else if (this.page == 'Invoice') {
      this._accountService.getInvoiceById(row.id).subscribe({
        next: (res: IInvoiceByIdResponseObject) => {
          if (!res.isError) {
            const accountData = res.value;
          }

          this.router.navigate(
            ['/klusup/accounting/invoice/invoice-details/', res.value.id],
            { state: { data: res.value } },
          );
        },
      });
    } else if (this.page == 'Payments') {
      this._transactionService.getTransactionLogsById(row.id).subscribe({
        next: (res: any) => {
          if (!res.isError) {
            const stripeLogData = res.value;
          }
          this.router.navigate(
            ['/klusup/accounting/payments/stripe/', row.id],
            { state: { data: res.value } },
          );
        },
      });
    } else {
      this._snackBar.open('Navigates to selected record details.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  goBack() {
    if (sessionStorage.getItem('parentNave')) {
      this.router.navigate([
        `/klusup/${sessionStorage.getItem('parentNav')?.toLocaleLowerCase()}/${this.page.toLocaleLowerCase()}`,
      ]);
    } else {
      this.router.navigate([
        `/klusup/accounting/${this.page.toLocaleLowerCase()}`,
      ]);
    }
  }

  onMatPageChange(page: PageEvent): void {
    this.receivedData = [];
    this.pageSize = page.pageSize; // Update page size if needed
    this.pageOffset = page.pageIndex * this.pageSize; // Calculate page offset for API calls
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const searchSessionParams = sessionStorage.getItem('searchParams') || '';
    const searchParams = {
      filterField: JSON.parse(searchSessionParams).filterField,
      filterValue: JSON.parse(searchSessionParams).filterValue,
      pageSize: this.pageSize,
      pageOffset: this.pageOffset,
    };
    const searchpage =
      this.page == 'Account'
        ? 'contacts'
        : this.page == 'Payments'
          ? 'stripeTransactions'
          : 'invoices';
    this.authService.search(searchParams, searchpage).subscribe({
      next: (response: any) => {
        this.receivedData = response.value.searchResults;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this._snackBar.open(
          `Error while fetching search data: ${error}`,
          'Close',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          },
        );
      },
    });
  }
}
